export default __webpack_public_path__ + "static/media/s2.0aa72fb8.jpg";